





















import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import TaskApi from '@/api/task.ts'

@Component
export default class liaisonCard extends Vue {
	private manual2Injured: boolean = true

	@Prop()
	private data: any

	@Watch('manual2Injured', { immediate: true })
	private onManual2Injured() {
		this.$emit('manual2Injured', this.manual2Injured)
	}

	private changeManual2Injured() {
		this.manual2Injured = !this.manual2Injured
	}

	private activated() {
		this.$emit('manual2Injured', this.manual2Injured)
	}

	private async created() {
		let sendManual = await TaskApi.isSendManual(this.data.insuranceType)
		this.manual2Injured = sendManual.data
	}
}
